export default {
    mounted() {
        document.addEventListener('DOMContentLoaded', function(event) {
            const elements = document.getElementsByClassName("track");

            const track = function () {
                const category = this.getAttribute("data-category") || '';
                const action = this.getAttribute("data-action") || '';
                const label = this.getAttribute("data-label") || '';
                const name = this.getAttribute("data-name") || 0;
                const form = this.getAttribute("data-form-name") || 0;

                if (category || action || label || name || form) {
                    gtag('event', 'click', {
                        'event_category': category,
                        'event_action': action,
                        'event_label': label,
                        'event_name': name,
                        'form_name': form,
                    })
                }
            };

            Array.from(elements).forEach(function (element) {
                element.addEventListener('click', track);
            });
        })
    },
}

